import { HYDRATE } from "next-redux-wrapper"
import _isEmpty from "lodash/isEmpty"
import { aemAxiosInstance, apim } from "@/constants/api"
import { getConfig } from "@/constants/config"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import qs from "qs"

import CONS, {
  GET_PROFILE_ENDPOINT,
  GLOBAL_CONFIGURATION_ENDPOINT,
  SEARCH_PLP_ENDPOINT,
  ZIP_FILE_DOWNLOAD_ENDPOINT,
  EDIT_PROFILE_ENDPOINT,
  addAddressEndPoint,
  DELETE_ACCOUNT_ENDPOINT,
  CHANGE_ACCOUNT_PASSWORD_ENDPOINT,
} from "@/constants/index"
import {
  getShortenedUrl,
  mapStateToCountryHandler,
  arrayMove,
} from "@/utils/helper"
import { addToCart } from "@/store/features/cartSlice"
import { store } from "@/store"

const initialState = {
  isLoading: false,
  datalayerPageName: "",
  eventPageType: "",
  accountTypeListPath: "",
  businessListPath: "",
  countryListPath: "",
  occupationListPath: "",
  commonListPath: "",
  trackingListPath: "",
  stateListPath: "",
  cardTypesPath: "",
  storeCountryListPath: "",
  placeOfPurchaseListPath: "",
  accountTypeList: [],
  businessList: [],
  checkoutErrorList: [],
  checkoutErrorsPath: "",
  legalPageLinks: {},
  countryList: [],
  stateList: [],
  stateToCountryList: [],
  placeOfPurchaseList: [],
  cardType: "",
  userMenuFragment: "",
  guestMenuFragment: "",
  status: "",
  error: "",
  subscribeModal: {
    show: false,
    modalContent: {},
    active: 0,
  },
  siteWideWarning: {
    isRendered: false,
  },
  newslettersignup: {},
  compareproducts: {},
  profile: "",
  brandLogoImg: "",
  globalScripts: [],
  dataLayerObj: "",
  analyticsScript: "",
  globalStyles: [],
  globalConfig: {},
  authorData: {},
  toaster: {
    message: "",
    isVisible: false,
    content: {},
  },
  menu: {
    isOpen: false,
    mainCategoryActive: "",
    isRegionOpen: false,
    isAuthNavOpen: false,
  },
  pageIsInteractive: false,
  previewCart: { showPreview: false },
  promoBannerModal: {
    show: false,
    modalContent: { banner: {}, item: {}, count: 0 },
  },
  enableSiteWideWarning: false,
  FindingModelModal: {
    show: false,
    modalContent: {},
  },
  associateMembershipModal: {
    show: false,
    isRetired: false,
    modalContent: {},
  },
  showHalfCompare: false,
  showFullCompare: false,
  isProductInfo: false,
  isPreviewCartInit: false,
  consolidatedZipCodes: [],
  upsellInstallationServiceAuthData: {},
  isShowAppointmentModal: false,
  bpNumber: null,
  gatedContentData: {},
  featureFlags: {},
  isPlaceOrderLoading: false,
}

export const getGenericListPath = createAsyncThunk(
  "generic/getGenericListPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()

    const accountTypeListPath = state?.generic?.accountTypeListPath ?? ""
    const businessListPath = state?.generic?.businessListPath ?? ""
    const countryListPath = state?.generic?.countryListPath ?? ""
    const occupationListPath = state?.generic?.occupationListPath ?? ""
    const commonListPath = state?.generic?.commonListPath ?? ""
    const trackingListPath = state?.generic?.trackingListPath ?? ""
    const stateListPath = state?.generic?.stateListPath ?? ""
    const cardTypesPath = state?.generic?.cardTypesPath ?? ""
    const placeOfPurchaseListPath =
      state?.generic?.placeOfPurchaseListPath ?? ""
    const storeCountryListPath = state?.generic?.placeOfPurchaseListPath ?? ""
    const checkoutErrorsPath = state?.generic?.checkoutErrorsPath ?? ""
    let data = {}

    if (
      accountTypeListPath ||
      businessListPath ||
      countryListPath ||
      occupationListPath ||
      commonListPath ||
      trackingListPath ||
      stateListPath ||
      cardTypesPath ||
      checkoutErrorsPath ||
      placeOfPurchaseListPath ||
      (storeCountryListPath && !reload)
    ) {
      data = {
        accountTypeList: accountTypeListPath,
        businessList: businessListPath,
        countryList: countryListPath,
        occupationList: occupationListPath,
        commonList: commonListPath,
        trackingList: trackingListPath,
        stateList: stateListPath,
        cardTypes: cardTypesPath,
        placeOfPurchaseList: placeOfPurchaseListPath,
        storeCountryListPath: storeCountryListPath,
        checkoutErrorList: checkoutErrorsPath,
      }
      return data
    }

    const { general } = await getConfig()
    if (general?.genericListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + general?.genericListPath
      )

      return response.data
    }
    return data
  }
)
export const getCardType = createAsyncThunk(
  "generic/cardTypesPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const cardTypesPath = state?.generic?.cardTypesPath
    if (cardTypesPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + cardTypesPath
      )
      return response.data
    }
    return {}
  }
)

export const getOrderStatus = createAsyncThunk(
  "generic/orderStatusesPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const orderStatusesPath = state?.generic?.orderStatusesPath
    if (orderStatusesPath) {
      const { data } = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + orderStatusesPath
      )
      return data
    }
    return {}
  }
)

export const getTrackingList = createAsyncThunk(
  "generic/trackingListPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const trackingListPath = state?.generic?.trackingListPath
    if (trackingListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + trackingListPath
      )
      return response.data
    }
    return {}
  }
)

export const getBusinessList = createAsyncThunk(
  "generic/getBusinessList",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const businessList = state?.generic?.businessList
    if (businessList?.length > 0 && !reload) return businessList
    const businessListPath = state?.generic?.businessListPath
    if (businessListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + businessListPath
      )
      return response.data
    }
    return []
  }
)

export const getCheckoutErrorList = createAsyncThunk(
  "generic/getCheckoutErrorList",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const checkoutErrorList = state?.generic?.checkoutErrorList
    if (checkoutErrorList?.length > 0 && !reload) return checkoutErrorList
    const checkoutErrorsPath = state?.generic?.checkoutErrorsPath
    if (checkoutErrorsPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + checkoutErrorsPath
      )
      return response.data
    }
    return []
  }
)

export const getAccountBusinessList = createAsyncThunk(
  "generic/getAccountBusinessList",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const accountTypeList = state?.generic?.accountTypeList
    if (accountTypeList?.length > 0 && !reload) return accountTypeList
    const accountTypeListPath = state?.generic?.accountTypeListPath
    if (accountTypeListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + accountTypeListPath
      )
      return response.data
    }
    return []
  }
)

export const getLegalPageLinks = createAsyncThunk(
  "generic/getLegalPageLinks",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const legalPageLinks = state?.generic?.legalPageLinks
    if (!_isEmpty(legalPageLinks) > 0 && !reload) return legalPageLinks
    const { general } = await getConfig()
    if (general?.legalPageListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + general?.legalPageListPath
      )
      return response.data
    }
    return {}
  }
)

export const getAuthMenuFragment = createAsyncThunk(
  "generic/getAuthMenuFragment",
  async ({ reload = false, path, fragmentName } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const fragment = state?.generic[fragmentName] ?? ""
    const payload = {}
    if (fragment && !reload) {
      payload[fragmentName] = fragment
      return payload
    }
    if (path) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + path
      )
      payload[fragmentName] =
        (await getShortenedUrl(response.data.commonTopics)) ?? ""
      return payload
    }
    return {}
  }
)

export const getProfile = createAsyncThunk("getprofile", async () => {
  const response = await apim.get(`${GET_PROFILE_ENDPOINT}`)
  return response.data
})

export const getOccupationList = createAsyncThunk(
  "generic/occupationListPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const occupationList = state?.generic?.occupationList
    if (occupationList?.length > 0 && !reload) return occupationList
    const occupationListPath = state?.generic?.occupationListPath
    if (occupationListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + occupationListPath
      )
      return response.data
    }
    return {}
  }
)

export const getCountryList = createAsyncThunk(
  "generic/countryListPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const countryList = state?.generic?.countryList
    if (countryList?.length > 0 && !reload) return countryList
    const countryListPath = state?.generic?.countryListPath
    if (countryListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + countryListPath
      )
      return response.data
    }
    return {}
  }
)
export const getstateList = createAsyncThunk(
  "generic/stateListPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const stateList = state?.generic?.stateList
    if (stateList?.length > 0 && !reload) return stateList
    const stateListPath = state?.generic?.stateListPath
    if (stateListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + stateListPath
      )
      return response.data
    }
    return {}
  }
)

export const getStoreCountriesList = createAsyncThunk(
  "generic/storeCountryListPath",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const storeCountryList = state?.generic?.storeCountryList
    if (storeCountryList?.length > 0 && !reload) return storeCountryList
    const storeCountryListPath = state?.generic?.storeCountryListPath
    if (storeCountryListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + storeCountryListPath
      )
      return response.data
    }
    return {}
  }
)

export const getplaceOfPurchaseList = createAsyncThunk(
  "generic/placeOfPurchaseList",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const placeOfPurchaseList = state?.generic?.placeOfPurchaseList
    if (placeOfPurchaseList?.length > 0 && !reload) return placeOfPurchaseList
    const placeOfPurchaseListPath = state?.generic?.placeOfPurchaseListPath
    if (placeOfPurchaseListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + placeOfPurchaseListPath
      )
      return response.data?.map(purchase => purchase.value)
    }
    return {}
  }
)

export const zipDownload = createAsyncThunk("zipDownload", async payload => {
  const response = await apim.post(ZIP_FILE_DOWNLOAD_ENDPOINT, payload, {
    responseType: "blob",
  })
  return response
})

export const searchPlp = createAsyncThunk("search-plp", async data => {
  const { internationalization: { language = "en" } = {} } = await getConfig()

  try {
    const actions = data.actions
    const response = await apim.get(SEARCH_PLP_ENDPOINT, {
      params: {
        q: "*:*",
        fl: "CustomerFacingBrand_s, RegionOnBackOrder_s",
        fq: [`sku_s:(${actions[0]?.sku})`, `language_s:("${language}")`],
        collections: "service_parts",
        profilename: "profile_service_parts_Search",
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat", encode: false })
      },
    })
    if (response?.data?.response?.docs[0]) {
      const newActions = []
      const newData = {}
      actions.forEach(action => {
        action["backorder"] =
          response.data.response.docs[0]["RegionOnBackOrder_s"] === "Yes"
        action["brand"] =
          response.data.response.docs[0]["CustomerFacingBrand_s"]
        newActions.push(action)
      })
      newData["actions"] = newActions
      return store.dispatch(addToCart(newData))
    }
  } catch (e) {
    return store.dispatch(addToCart(data))
  }
})

export const getUserProfile = createAsyncThunk("getuserprofile", async () => {
  let profile = {}
  try {
    const res = await apim.get(`${GET_PROFILE_ENDPOINT}`)
    if (res && res.data) {
      localStorage.setItem("profile-version", res.data.version)
      profile = res.data
      profile.postalCode = profile.addresses[0]?.postalCode
      const profileAddr = profile.addresses?.find(
        addr => addr.custom?.fields?.label === "Profile"
      )
      profile.profileAddrId = profileAddr.id
      profile.addresses = profile.addresses?.filter(
        addr => addr.custom?.fields?.label !== "Profile"
      )
      let addresses = profile.addresses
      if (profile.defaultShippingAddressId) {
        const index = addresses.findIndex(
          item => item.id === profile.defaultShippingAddressId
        )
        addresses = arrayMove(profile.addresses, index, 0)
      }
      profile.addresses = addresses
    }
  } catch (err) {
    console.log("Failed to get user profile", err)
  }
  return profile
})
export const editProfile = createAsyncThunk(
  "editProfile",
  async (data, thunkAPI) => {
    let profile = []
    let actions = []
    const oktaTokenStorage = JSON.parse(
      localStorage.getItem("okta-token-storage")
    )
    const userType =
      oktaTokenStorage.accessToken.claims.persona[0].split(":")[1]
    if (userType === "TVS") {
      actions = [
        {
          action: "setFirstName",
          firstName: data.firstName,
        },
        {
          action: "setLastName",
          lastName: data.lastName,
        },
        {
          action: "setCompanyName",
          companyName: data.businessName,
        },
        {
          action: "setCustomField",
          name: "businessType",
          value: data.businessType,
        },
        {
          action: "setCustomField",
          name: "businessSubType",
          value: data.businessSubType,
        },
        {
          action: "changeAddress",
          addressId: data.addressId,
          address: {
            postalCode: data.businessZipCode,
            country: "US",
            custom: {
              type: {
                key: "custom-address",
              },
              fields: {
                label: "Profile",
              },
            },
          },
        },
      ]
    } else {
      actions = [
        {
          action: "setFirstName",
          firstName: data.firstName,
        },
        {
          action: "setLastName",
          lastName: data.lastName,
        },
      ]
    }
    const version = parseInt(localStorage.getItem("profile-version")) ?? 1
    try {
      const res = await apim.post(`${EDIT_PROFILE_ENDPOINT}`, {
        version: version,
        actions: actions,
      })
      if (res) {
        profile = await thunkAPI.dispatch(getUserProfile())

        localStorage.setItem(CONS?.KF_FORCE_RENEW_TOKEN, true)
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Failed to edit profile", err)
    }
    const { payload: response } = profile
    return response
  }
)
export const addAddress = createAsyncThunk("addAddress", async data => {
  const resPayload = {
    addresses: [],
    defaultShippingAddressId: "",
  }
  const version = parseInt(localStorage.getItem("profile-version")) ?? 1
  try {
    const payload = Array.isArray(data)
      ? {
          version: version,
          actions: data,
        }
      : {
          version: version,
          actions: [
            {
              action: "addAddress",
              address: data,
            },
          ],
        }
    const res = await apim.post(`${addAddressEndPoint}`, payload)
    if (res && res?.data) {
      localStorage.setItem("profile-version", res?.data?.version)
      if (res?.data?.addresses?.length > 0) {
        resPayload.addresses =
          res?.data?.addresses?.filter(
            addr => addr?.custom?.fields?.label !== "Profile"
          ) ?? []
        resPayload.defaultShippingAddressId =
          res?.data?.defaultShippingAddressId
      }
    }
  } catch (err) {
    console.log("Failed to add address", err)
    const { response: { data: { error = "" } } = {} } = err
    return { error }
  }
  return resPayload
})
export const editAddress = createAsyncThunk("editAddress", async payload => {
  const resPayload = {
    addresses: [],
    defaultShippingAddressId: "",
  }
  const version = parseInt(localStorage.getItem("profile-version")) ?? 1
  try {
    const res = await apim.post(`${addAddressEndPoint}`, {
      version: version,
      actions: [
        {
          action: "changeAddress",
          addressId: payload?.id,
          address: payload?.addr,
        },
      ],
    })
    if (res && res?.data) {
      localStorage.setItem("profile-version", res.data.version)
      if (res?.data?.addresses?.length > 0) {
        resPayload.addresses =
          res?.data?.addresses?.filter(
            addr => addr?.custom?.fields?.label !== "Profile"
          ) ?? []
        resPayload.defaultShippingAddressId =
          res?.data?.defaultShippingAddressId
      }
    }
  } catch (err) {
    console.log("Failed to edit address", err)
  }
  return resPayload
})
export const setDefaultAddress = createAsyncThunk(
  "setDefaultAddress",
  async addressId => {
    const resPayload = {
      addresses: [],
      defaultShippingAddressId: "",
    }
    const version = parseInt(localStorage.getItem("profile-version")) ?? 1
    try {
      const res = await apim.post(`${addAddressEndPoint}`, {
        version: version,
        actions: [
          {
            action: "setDefaultShippingAddress",
            addressId: addressId,
          },
        ],
      })
      if (res && res?.data) {
        localStorage.setItem("profile-version", res?.data?.version)
        if (res?.data?.addresses?.length > 0) {
          resPayload.addresses =
            res?.data?.addresses?.filter(
              addr => addr?.custom?.fields?.label !== "Profile"
            ) ?? []
          resPayload.defaultShippingAddressId =
            res?.data?.defaultShippingAddressId
        }
      }
    } catch (err) {
      console.log("Failed to set default", err)
    }
    return resPayload
  }
)
export const removeAddress = createAsyncThunk(
  "removeAddress",
  async addressId => {
    const resPayload = {
      addresses: [],
      defaultShippingAddressId: "",
    }
    const version = parseInt(localStorage.getItem("profile-version")) ?? 1
    try {
      const res = await apim.post(`${addAddressEndPoint}`, {
        version: version,
        actions: [
          {
            action: "removeAddress",
            addressId: addressId,
          },
        ],
      })
      if (res && res?.data) {
        localStorage.setItem(
          "profile-version",
          res?.data.profileDetail?.version
        )
        if (res?.data?.profileDetail?.addresses?.length > 0) {
          resPayload.addresses =
            res?.data?.profileDetail?.addresses?.filter(
              addr => addr?.custom?.fields?.label !== "Profile"
            ) ?? []
          resPayload.defaultShippingAddressId =
            res?.data?.profileDetail?.defaultShippingAddressId
        }
      }
    } catch (err) {
      console.log("Failed to remove address", err)
    }
    return resPayload
  }
)

export const deleteAccount = createAsyncThunk("deleteAccount", async () => {
  try {
    const res = await apim.delete(`${DELETE_ACCOUNT_ENDPOINT}`)
    if (res && res.data) return true
  } catch (err) {
    console.log("Failed to delete account", err)
  }
})

export const resetPassword = createAsyncThunk("resetPassword", async data => {
  try {
    return await apim.post(`${CHANGE_ACCOUNT_PASSWORD_ENDPOINT}`, data)
  } catch (err) {
    console.log("Failed to reset password", err)
    return err.response
  }
})

export const uploadImage = createAsyncThunk("", async file => {
  const fileName = file?.name?.toLowerCase()?.replace(/ /g, "-")
  const res = await apim.put(`/crm/asset/upload?fileName=${fileName}`, file, {
    headers: { "Content-Type": file.type },
  })

  if (res && res.data) return res.data
})

export const getCommonList = createAsyncThunk(
  "generic/getCommonList",
  async ({ reload = false } = {}, thunkAPI) => {
    const state = thunkAPI.getState()
    const commonList = state?.generic?.commonList
    if (commonList?.length > 0 && !reload) return commonList
    const commonListPath = state?.generic?.commonListPath
    if (commonListPath) {
      const response = await aemAxiosInstance.get(
        GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + commonListPath
      )
      return response.data
    }
    return []
  }
)

export const genericSlice = createSlice({
  name: "generic",
  initialState,
  reducers: {
    setSubscribeModalContent(state, action) {
      state.subscribeModal = {
        ...state.subscribeModal,
        modalContent: action.payload,
      }
    },
    setCompareproductsStaticText(state, action) {
      state.compareproducts = {
        ...state.compareproducts,
        content: action.payload,
      }
    },
    setSitewideWarningContent(state, action) {
      state.siteWideWarning = {
        ...state.subscribeModal,
        content: action.payload,
      }
    },

    setSitewideNewsLetterContent(state, action) {
      state.newslettersignup = {
        ...state.newslettersignup,
        content: action.payload,
      }
    },

    setSitewideWarningRendered(state, action) {
      state.siteWideWarning = {
        ...state.subscribeModal,
        isRendered: action.payload,
      }
    },
    setBrandLogoImg(state, action) {
      state.brandLogoImg = action.payload
    },

    setGlobalScripts(state, action) {
      state.globalScripts = state.globalScripts.concat(action.payload)
    },
    setDataLayerObj(state, action) {
      state.dataLayerObj = action.payload
    },

    setGlobalStyles(state, action) {
      state.globalStyles = state.globalStyles.concat(action.payload)
    },
    setGlobalConfig(state, action) {
      state.globalConfig = action.payload
    },
    setAuthorData(state, action) {
      state.authorData = action.payload
    },
    setLoading(state, action) {
      state.isLoading = action.payload
    },
    setAnalyticsScript(state, action) {
      state.analyticsScript = action.payload
    },
    showToast(state, action) {
      state.toaster = {
        ...state.toaster,
        ...action.payload,
      }
    },
    hideToast(state, action) {
      state.toaster = {
        ...state.toaster,
        message: "",
        isVisible: false,
      }
    },
    setToastContent(state, action) {
      state.toaster = {
        ...state.toaster,
        content: action.payload,
      }
    },
    openMenu(state, action) {
      state.menu = {
        ...state.menu,
        isOpen: true,
      }
    },
    closeMenu(state, action) {
      state.menu = {
        ...state.menu,
        isOpen: false,
      }
    },
    setActiveMainCategory(state, action) {
      state.menu = {
        ...state.menu,
        mainCategoryActive: action.payload.item,
      }
    },
    setRegionNav(state, action) {
      state.menu = {
        ...state.menu,
        isRegionOpen: action.payload,
      }
    },
    setAuthNav(state, action) {
      state.menu = {
        ...state.menu,
        isAuthNavOpen: action.payload,
      }
    },
    setPageIsIntercative(state, action) {
      state.pageIsInteractive = action.payload
    },
    showPreviewCart(state, action) {
      window.previewCartKeySource = false
      state.previewCart = {
        ...state.previewCart,
        showPreview: true,
      }
    },
    hidePreviewCart(state, action) {
      window.previewCartKeySource = true
      state.previewCart = {
        ...state.previewCart,
        showPreview: false,
      }
    },

    setDatalayerPageName(state, action) {
      let trimmed = action.payload
      // will remove .model.json from the incoming string
      trimmed = trimmed ? trimmed.replace(".model.json", "") : trimmed
      state.datalayerPageName = trimmed
    },
    setGbhDataLayerCustom(state, action) {
      const { datalayerPageName, eventPageType, pageType } = action.payload
      if (datalayerPageName) {
        state.datalayerPageName = datalayerPageName
      } else {
        state.datalayerPageName = ""
      }
      if (eventPageType) {
        state.eventPageType = window.eventPageType = eventPageType
      } else {
        state.eventPageType = ""
      }
      if (pageType) {
        state.pageType = window.pageType = pageType
      } else {
        state.pageType = ""
      }
      const { adobeDataLayer: { getState } = {} } = window
      const page = (getState && getState("page")) || {}
      const content = page?.pageInfo?.contentType
      if (content === "locations") {
        state.eventPageType = "locations:kohler stores"
      }
    },
    showPromoModal(state, action) {
      state.promoBannerModal = {
        ...action.payload,
      }
    },
    mapStateToCountry: (state, action) => {
      const { countryList, stateList } = action.payload
      const stateToCountryList = mapStateToCountryHandler(
        countryList,
        stateList
      )
      state.stateToCountryList = stateToCountryList
    },
    toggleSiteWideWarning: (state, action) => {
      state.enableSiteWideWarning = !state.enableSiteWideWarning
    },
    showFindingModelPopup(state, action) {
      state.FindingModelModal = {
        show: true,
        modalContent: {},
      }
    },
    hideFindingModelPopup(state, action) {
      state.FindingModelModal = {
        show: false,
        modalContent: {},
      }
    },
    setShowHalfCompare(state, action) {
      state.showHalfCompare = action.payload
    },

    setShowFullCompare(state, action) {
      state.showFullCompare = action.payload
    },
    setPageObject(state, action) {
      state.isProductInfo = action.payload
    },
    setPreviewCartInit(state, action) {
      state.isPreviewCartInit = action.payload
    },
    setConsolidatedZipCodes(state, action) {
      state.consolidatedZipCodes = action.payload
    },
    setUpsellInstallationServiceData(state, action) {
      state.upsellInstallationServiceAuthData = action.payload
    },
    showAppointmentModal: (state, action) => {
      state.isShowAppointmentModal = true
      state.bpNumber = action.payload
    },
    hideAppointmentModal: state => {
      state.isShowAppointmentModal = false
    },
    setGatedContentData: (state, action) => {
      state.gatedContentData = action.payload
    },
    setFeatureFlagsFeature: (state, action) => {
      state.featureFlags = action.payload
    },
    setPlaceOrderLoading(state, action) {
      state.isPlaceOrderLoading = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase([HYDRATE], (state, action) => {
        return {
          ...state,
          ...action.payload.generic,
        }
      })
      .addCase(getGenericListPath.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getGenericListPath.fulfilled, (state, action) => {
        state.status = "succeeded"
        const data = action.payload
        for (const key of Object.keys(data)) {
          state[key + "Path"] = data[key]
        }
      })
      .addCase(getGenericListPath.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getBusinessList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getBusinessList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.businessList = action.payload
      })
      .addCase(getBusinessList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getCheckoutErrorList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getCheckoutErrorList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.checkoutErrorList = action.payload
      })
      .addCase(getCheckoutErrorList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getAccountBusinessList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getAccountBusinessList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.accountTypeList = action.payload
      })
      .addCase(getAccountBusinessList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getLegalPageLinks.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getLegalPageLinks.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.legalPageLinks = action.payload
      })
      .addCase(getLegalPageLinks.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getAuthMenuFragment.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getAuthMenuFragment.fulfilled, (state, action) => {
        state.status = "succeeded"
        for (const key in action.payload) {
          if ({}.hasOwnProperty.call(action.payload, key)) {
            state[key] = action.payload[key]
          }
        }
      })
      .addCase(getAuthMenuFragment.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getCountryList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.countryList = action.payload
      })
      .addCase(getCountryList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getOccupationList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getOccupationList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.countryList = action.payload
      })
      .addCase(getOccupationList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getstateList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getstateList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.stateList = action.payload
      })
      .addCase(getStoreCountriesList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getStoreCountriesList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getStoreCountriesList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.stateList = action.payload
      })
      .addCase(getstateList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getplaceOfPurchaseList.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getplaceOfPurchaseList.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.placeOfPurchaseList = action.payload
      })
      .addCase(getplaceOfPurchaseList.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getCardType.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getCardType.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.cardType = action.payload
      })
      .addCase(getCardType.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
      .addCase(getOrderStatus.pending, (state, action) => {
        state.status = "loading"
      })
      .addCase(getOrderStatus.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.orderStatus = action.payload
      })
      .addCase(getOrderStatus.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error.message
      })
  },
})

export const {
  setLoading,
  setCompareproductsStaticText,
  setSubscribeModalContent,
  setSitewideWarningContent,
  setSitewideWarningRendered,
  setBrandLogoImg,
  setGlobalScripts,
  setGlobalStyles,
  setGlobalConfig,
  setAuthorData,
  setDataLayerObj,
  setAnalyticsScripts,
  setCompareExpiry,
  showToast,
  clearAllCompareProducts,
  showPreviewCart,
  hidePreviewCart,
  hideToast,
  openMenu,
  closeMenu,
  setActiveMainCategory,
  setRegionNav,
  setAuthNav,
  setAnalyticsScript,
  setPageIsIntercative,
  setDatalayerPageName,
  setGbhDataLayerCustom,
  setSitewideNewsLetterContent,
  setToastContent,
  showPromoModal,
  mapStateToCountry,
  toggleSiteWideWarning,
  showFindingModelPopup,
  hideFindingModelPopup,
  setShowHalfCompare,
  setShowFullCompare,
  setPageObject,
  setPreviewCartInit,
  setConsolidatedZipCodes,
  setUpsellInstallationServiceData,
  showAppointmentModal,
  hideAppointmentModal,
  setGatedContentData,
  setFeatureFlagsFeature,
  setPlaceOrderLoading,
} = genericSlice.actions
export const selectGenericState = state => state.generic
export default genericSlice.reducer
